export const DEFAULT_PER_PAGE_RESULTS = 108;

export const PRODUCT_CLOSE_PREVIEW = 'product_close';
export const ALTERNATE_PRODUCT_CLOSE_PREVIEW = 'alternate_product_close';
export const ARTWORK_PREVIEW = 'artwork';

// Stores the inventory item id clicked by the user on search results page.
export const LAST_CLICKED_ITEM_ID_COOKIE = 'last_clicked_item_id';

export const FIND_SEARCH_TYPE = 'find';
export const BROWSE_SEARCH_TYPE = 'browse';

export const ALL_DEPARTMENTS = 'all-departments';

export const RESULT_PER_PAGE_LOGGED_IN = 84;
export const RESULT_PER_PAGE_LOGGED_OUT = 82;

export const GENDER_WOMEN_FILTER = 'gender-women';
